module.exports = __webpack_public_path__ + "static/media/experience-vr.de8a4064.png";